<template>
  <div>
    <p class="light-gray">
      {{ $t('placeholder.gender') }}
    </p>
    <el-select
      v-model="genderValue"
      class="gender-select"
      @change="chooseGender"
    >
      <el-option
        v-for="gender in genderOptions"
        :key="gender.value"
        :value="gender.value"
        :label="gender.label"
      />
    </el-select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Gender',
  data() {
    return {
      genderValue: null,
      genderOptions: [
        {
          value: 2,
          label: this.$t('common.female')
        },
        {
          value: 1,
          label: this.$t('common.male')
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      searchGender: 'search/searchGender'
    })
  },
  watch: {
    searchGender: {
      immediate: true,
      handler() {
        if (this.searchGender === 1) {
          this.genderValue = this.$t('common.male')
        } else if (this.searchGender === 2) {
          this.genderValue = this.$t('common.female')
        } else {
          this.genderValue = null
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setGender: 'search/SET_GENDER'
    }),
    chooseGender() {
      this.setGender(this.genderValue)
    },
    //  maybe should be deleted
    resetGender() {
      this.setGender(0)
      this.genderValue = undefined
    }
  }
}
</script>

<style scoped lang="scss">
.gender-select {
  width: 100%;
}
</style>
